
interface cardType {
    image : string,
    isPreOrder : boolean,
    description : string,
    name : string
    isNew : boolean
    launch : string
    isSelected : boolean
}

const Card:React.FC<cardType> = ({image, isPreOrder, description, name, isNew, launch, isSelected}) => {

    return (
<>
<div className={` rounded-3 shadow h-100 p-0 position-relative overflow-hidden ${isSelected && 'opacity-75 shadow-md'}`} 
     role="button">
            <figure className="has-object-fit m-0" title={description}>
               
                <img className="img-fluid ls-is-cached lazyloaded" 
                     src={image + '?width=300'} 
                     data-src={image + '?width=600'} 
                     alt={name + ' brochure'}
                     title={name + ' brochure'}/>
             
            </figure>
        {isNew && <div className="new"><span>NEW</span></div>}
    </div>
    {isPreOrder && 
        <p className="text-center position-absolute bottom-0 bg-light m-0 p-3 w-100 bg-opacity-75 text-strong">
            <span className="">PREORDER</span> <br/> Released on {launch}
        </p>}
    {isSelected &&
    <span className="position-absolute top-0 start-0 m-2">
        <svg height="30" width="30" xmlns="http://www.w3.org/2000/svg" className="position-absolute top-0 start-0">
        <circle fill="#2faf" cx={'15'} cy={'15'} r={'15'}/>
          <path fill="#2a2a2a" d="M13,19.4l-4-4,1.4-1.4,2.6,2.6,6.6-6.6,1.4,1.4-8,8Z"/>
        </svg>
    </span>
}
</>
    
    )
}
export default Card